import { render } from "./VModalContent.vue?vue&type=template&id=6b19b3e6&ts=true"
import script from "./VModalContent.vue?vue&type=script&lang=ts"
export * from "./VModalContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__